@if(!cardDisplay()){
	<div [class.w-80]="!fullWidth()" class="hero-binder rounded-box">
		<img class="img-binder" [altImg]="getBinderImg()" hSkeleton="427px" wSkeleton="100%"/>
		<div class="binder-container">
			<!-- favoris -->
			<div [ngClass]="{'back-container': back()}" class="fav-container">
				<!-- div qui permet d'aller au binder -->
				<div class="go-to" (click)="goTo()"></div>
				@if(back() && admin()){
					<a [routerLink]="back()" class="back add-fav glass rounded-full bg-black/40">
						<i class="fa-regular fa-chevron-left"></i>
					</a>
				}
				@if(admin()){
					<div class="share-container">
						<a (click)="toggleFavoriteBinder()" class="add-fav glass rounded-full bg-black/40 mb-2">
							<i [ngClass]="{'fa-solid': uBinder()?.isFavorite, 'fa-light': !uBinder()?.isFavorite}" class="fa-bookmark"></i>
						</a>
						<lgb-share [element]="uBinder()" typeElement="binder">
					   		<span class="add-fav glass rounded-full bg-black/40 mb-3">
					   			<i class="fa-light fa-paper-plane"></i>
						    </span>
						</lgb-share>

						<button (click)="setScan($event)" class="btn btn-primary btn-gradient">
							<i class="add-item size-[1.5em] fa-regular fa-grid-2-plus"></i>
						</button>
					</div>
				}
			</div>

			<!-- info -->
			<div (click)="goTo()" class="info-container glass bg-black/40">
				<div class="left">
					<p class="truncate binder-name font-serra">{{binder()?.name || 'Non référencé'}}</p>
					<p class="nb-card mt-1">
						<i class="fa-regular fa-hashtag mr-2"></i> {{((binder())? uBinder().ident : 'Pas de code')}}
					</p>
				</div>
				<div class="right">
					<p>Valeur</p>
					{{uBinder()?.amount | number:'1.0-0':'fr-FR' }}€
				</div>
			</div>
		</div>
	</div>
}
@else{
	<div class="card bg-base-100 shadow-sm">
	  <figure class="card-img-container">
	   	<img (click)="goTo()" hSkeleton="200px" [altImg]="getBinderImg()"/>
	  </figure>

	  <!-- actions -->
	  <div class="card-body">
		<div (click)="goTo()" class="info-container glass bg-black/40">
			<p class="truncate binder-name font-serra">{{binder()?.name || 'Non référencé'}}</p>
			<p class="nb-card mt-1">
				<i class="fa-regular fa-hashtag mr-2"></i> {{((binder())? uBinder().ident : 'Pas de code')}}
			</p>
		</div>

		@if(admin()){
		    <div class="card-actions">
		    	<lgb-share [element]="uBinder()" typeElement="binder">
			   		<span class="btn text-primary">
			   			<i class="fa-light fa-paper-plane"></i>
				    </span>
				</lgb-share>
				<a (click)="toggleFavoriteBinder()" class="btn text-primary mx-1">
					<i [ngClass]="{'fa-solid': uBinder()?.isFavorite, 'fa-light': !uBinder()?.isFavorite}" class="fa-bookmark"></i>
				</a>
			    <div class="add-btn-container ml-1">
					<button (click)="setScan($event)" class="btn btn-primary btn-gradient litle-btn-gradient">
						<i class="add-item size-[1.5em] fa-regular fa-grid-2-plus"></i>
					</button>
				</div>
		    </div>
		}
	  </div>
	</div>
}